<template>
  <div class="container">   
    <div class="column col-6 col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xl-8">
      <form class="form-horizontal">
        
        <div class="form-group">
          <div class="container">
            <div class="columns">
              <div class="column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <label class="form-label">Client</label>
              </div>
              <div class="column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <searchClients v-on:selected="selectClient"></searchClients>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="container">
            <div class="columns">
              <div class="column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <label class="form-label">Matter description</label>
              </div>
              <div class="column col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <select v-model="invoice.matter_desc" class="form-select">
                  <option value="" selected>Select</option>
                  <option v-for="type in visatypes" :value="type.name">{{type.name}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div v-if="user && user.stripe_id" class="container">
            <div class="columns">
              <div class="column col-3 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <label class="form-label">Instant payment</label>
              </div>
              <div class="column col-7 col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
                <label class="form-switch">
                  <input v-model="instant_payment" type="checkbox">
                  <i class="form-icon"></i>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="container">
            <div class="columns">
              <div class="column col-4 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <label class="form-label">No GST</label>
              </div>
              <div class="column col-8 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                <label class="form-checkbox">
                  <input v-model="no_gst" type="checkbox">
                  <i class="form-icon"></i>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="col-12">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Cost</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <select v-model="newItem.description" class="form-select" v-on:change="selItem">
                      <option value="">Select</option>
                      <option v-for="d in descriptions" :value="d">{{d}}</option>
                    </select>
                  </td>
                  <td>
                    <div class="input-group">
                      <span class="input-group-addon">$</span>
                      <input v-model.number="newItem.cost" class="form-input" type="number" step="0.01">
                    </div>
                  </td>
                  <td><button @click.prevent="addItem" class="btn btn-primary btn-sm"><i class="icon icon-plus"></i></button></td>
                </tr>
                <tr v-for="(item, i) in invoice.items">
                  <td>{{item.description}}</td>
                  <td>${{c2d(item.cost)}}</td>
                  <td><button @click.prevent="delItem(i)" class="btn btn-sm"><i class="icon icon-minus"></i></button></td>
                </tr>
                <tr v-if="totals[0]">
                  <td></td>
                  <td>GST</td>
                  <td>${{c2d(totals[0])}}</td>
                </tr>
                <tr v-if="totals[1]">
                  <td></td>
                  <td>Surcharge</td>
                  <td>${{c2d(totals[1])}}</td>
                </tr>
                <tr v-if="totals[2]">
                  <td></td>
                  <td>Total</td>
                  <td>${{c2d(totals[2])}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="form-group">
          <div class="container">
            <div class="columns">
              <div class="column col-4 col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                <label class="form-label">Payment plan</label>
              </div>
              <div class="column col-8 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                <label class="form-switch">
                  <input v-model="plan" type="checkbox">
                  <i class="form-icon"></i>
                </label>
              </div>
            </div>
          </div>
        </div>
               
        <div class="form-group">
          <div class="container">
             <div class="column col-6 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <div v-if="plan" class="input-group">
                <span class="input-group-addon">Initial&nbsppayment&nbsp$</span>
                <input v-model.number="plan_initial" class="form-input" type="number" min="0" step="0.01">
              </div>
            </div>
             <div class="column col-6 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <div v-if="plan" class="input-group">
                <span class="input-group-addon">Monthly&nbsppayment&nbsp$</span>
                <input v-model.number="plan_monthly" class="form-input" type="number" min="0" step="0.01">
              </div>
            </div>
          </div>
        </div>


        <div class="form-group">
          <div class="col-12">
            <button v-if="!success" @click.prevent="make" class="btn btn-primary" :class="{loading: isLoading}">Make</button>
            <span v-else class="label label-success">Success</span>
            <span v-if="errormsg" class="label label-error">{{errormsg}}</span>
            <button v-if="newInvoice" @click.prevent="showSendModal = true" class="btn btn-primary">Send</button>
            <button v-if="success" @click.prevent="reset" class="btn btn-primary">Clear</button>
          </div>
        </div>
      </form>


      <!-- OTHER ITEM MODAL -->
      <div class="modal" :class="{active: othermodal}">
        <div class="modal-overlay"></div>
        <div class="modal-container" style="width:64rem;">
          <div class="modal-body">
            <div class="content">
              <div class="form-group">
                <label class="form-label">Item description</label>
                <input v-model="newDesc" class="form-input">
              </div>
              <div class="form-group">
                <label class="form-checkbox">
                  <input type="checkbox" v-model="newItem.surcharge">
                  <i class="form-icon"></i> Surcharge
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn" @click.prevent="addDesc">Done</button>
          </div>
        </div>
      </div>
      <!-- END OTHER ITEM MODAL -->

      <sendModal :show="showSendModal"
                 :invoice="newInvoice"
                 v-on:close="showSendModal = false"
                 v-on:done="reset"></sendModal>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'
import sendInvoiceModal from '@/components/accounts/sendInvoiceModal'
import searchClients from '@/components/users/searchClients'
export default {
  name: 'makeInvoice',
  mixins: [utils],
  props: ['invoices'],
  components: {
    'sendModal': sendInvoiceModal,
    'searchClients': searchClients
  },
  data () {
    return {
      user: null,
      isLoading: false,
      success: false,
      errormsg: null,
      visatypes: [],
      instant_payment: false,
      no_gst: false,
      othermodal: false,
      showSendModal: false,
      newInvoice: null, // Newly made agreement returned from server
      newDesc: '',
      plan: false,
      plan_initial: 0,
      plan_monthly: 0,
      invoice: {
        matter_desc: '',
        items: [],
        initial: 0,
        monthly: 0
      },
      newItem: {
        description: '',
        surcharge: false,
        cost: 0
      },
      descriptions: utils.invoiceItems()
    }
  },
  created: function () {
    axios.get('/api/allvisatypes').then(res => {
      if (res.status === 200) {
        this.visatypes = res.data
      }
    })
  },
  computed: {
    totals: function () {
      // Calculate surcharge, GST and total
      let gst = 0
      let total = 0
      let surcharge = 0

      for (let i of this.invoice.items) {
        total += i.cost
        if (i.surcharge) {
          surcharge += i.cost
        } else if (!this.no_gst && i.cost > 0) { // Ignore discounts in GST
          gst += i.cost
        }
      }

      gst = parseInt(gst * 0.1)
      surcharge = parseInt(surcharge * 0.014)
      total = parseInt(total + surcharge + gst)

      return [gst, surcharge, total]
    }
  },
  watch: {
    plan: function () { if (this.plan) this.instant_payment = false },
    instant_payment: function () { if (this.instant_payment) this.plan = false }
  },
  methods: {
    selectClient: function (user) {
      this.user = user
    },
    reset: function () {
      this.invoice = {
        matter_desc: '',
        items: [],
        initial: 0,
        monthly: 0
      }
      this.success = false
      this.newInvoice = null
      this.showSendModal = false
      this.errormsg = null
    },
    c2d: function (c) {
      return (c / 100).toFixed(2)
    },
    addItem: function () {
      if (this.newItem.description.trim() === '') {
        return
      }
      this.newItem.cost *= 100 // Convert to cents
      this.invoice.items.push(this.newItem)
      this.newItem = {
        description: '',
        surcharge: false,
        cost: 0
      }
    },
    selItem: function () {
      if (this.newItem.description === 'Other') {
        this.othermodal = true
      }
    },
    delItem: function (i) {
      this.invoice.items.splice(i, 1)
    },
    addDesc: function () {
      this.othermodal = false
      this.newDesc = this.newDesc.trim()
      if (this.newDesc === '') return
      this.descriptions.push(this.newDesc)
      this.newItem.description = this.newDesc
      this.newDesc = ''
    },
    make: function () {
      this.errormsg = null

      if (this.invoice.items.length === 0) {
        this.errormsg = 'Invoice has no items'
        return
      }

      this.isLoading = true
      // utils.methods.delay(10000, () => { this.isLoading = false })

      // Set the required invoice fields
      let totals = this.totals // [gst, surcharge, total]
      this.invoice.gst = totals[0]
      this.invoice.surcharge = totals[1]
      this.invoice.total = totals[2]
      this.invoice.outstanding = totals[2]
      if (this.plan) {
        this.invoice.initial = this.plan_initial * 100
        this.invoice.monthly = this.plan_monthly * 100
      }

      let u = this.user
      let p = u.profile

      // Set the first part of the invoice reference
      // Format: JB0001 for Joe Blo's first invoice
      // The server will add the padded number
      if (p.corporate) {
        let bname = p.business.toUpperCase().replace(' &', '').split(' ')
        if (bname.length > 1) {
          this.invoice.ref = bname[0][0] + bname[1][0]
        } else {
          this.invoice.ref = bname[0][0] + (bname[0][1] || '_')
        }
      } else {
        this.invoice.ref = p.firstname[0] + (p.lastname[0] || '_')
      }

      this.invoice.user = u._id
      this.invoice.firstname = p.firstname
      this.invoice.lastname = p.lastname
      this.invoice.business = p.corporate ? p.business : null
      this.invoice.brand = p.brand || 'pl'
      this.invoice.date = new Date()
      this.invoice.plan = this.plan
      this.invoice.instant_payment = this.instant_payment

      axios.post('/api/invoices/new', this.invoice).then(res => {
        if (res.status === 200) {
          this.$emit('new')
          this.isLoading = false
          this.success = true
          this.newInvoice = res.data
        }
      }).catch(e => { console.log(e) })
    }
  }
}
</script>

<style scoped>
.flexcol {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// makeInvoice.vue?0d5baaca